<template>
    <div class="newsDetailWrap">
        <div class="newsDetail">
            <div class="backlistBtn" @click="goBack">
                <svg  class="closeBtnImg" t="1675307591789" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="25252" width="20" height="20">
                    <path d="M511.232 438.8352L112.9984 40.6016A51.2 51.2 0 0 0 40.6016 112.9984L438.784 511.232 40.6016 909.4656a51.2 51.2 0 1 0 72.3968 72.448l398.2336-398.2848 398.2336 398.2848a51.2 51.2 0 1 0 72.448-72.448l-398.2848-398.2336 398.2848-398.2336A51.2 51.2 0 0 0 909.4656 40.6016L511.232 438.784z" fill="#000000" p-id="25253"></path>
                </svg>
            </div>
            <div class="detail-content">
                <div class="news-image" v-if="newsItem.imgUrl">
                    <img :src="newsItem.imgUrl" :alt="newsItem.title" />
                </div>
                <h1 class="news-title">{{ newsItem.title }}</h1>
                <div class="news-meta">
                    <span class="news-date">{{ newsItem.date }}</span>
                </div>
                <div class="news-content">
                    <div v-if="newsItem.content" v-html="newsItem.content"></div>
                    <div v-else>新闻内容加载中...</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewsDetail',
    props: {
        newsItem: {
            type: Object,
            required: true,
            default: () => ({
                id: '',
                title: '',
                imgUrl: '',
                date: '',
                content: ''
            })
        }
    },
    methods: {
        goBack() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="less" scoped>
.newsDetailWrap {
    width: 100%;
    background: #ffffff;
    .newsDetail {
        max-width: 960px;
        margin: 0 auto;
        padding: 24px 24px 40px 24px;
        .backlistBtn{
            display: flex;
            align-content: center;
            justify-content: end;
            margin-bottom: 20px;
        }
        
        .detail-content {
            width: 100%;
            margin: 0 auto;
            
            .news-image {
                margin-bottom: 32px;
                text-align: center;
                
                img {
                    width: 100%;
                    height: auto;
                    border-radius: 8px;
                    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
                }
            }
            
            .news-title {
                font-size: 32px;
                color: #333;
                margin-bottom: 10px;
                line-height: 130%;
            }
            
            .news-meta {
                display: flex;
                align-items: center;
                margin-bottom: 32px;
                padding-bottom: 16px;
                border-bottom: 1px solid #eee;
                gap: 10px;
                
                .news-date {
                    color: #666;
                    font-size: 14px;
                }

            }
            
            .news-content {
                line-height: 150%;
                font-size: 16px;
                color: #444;
                span {
                    color: pink;
                }
                img {
                    width: 100%;
                    height: auto;
                }
                div {
                    max-width: 100%;
                    p {
                        display: inline-block;
                        width: 100%;
                        margin-bottom: 16px;
                        max-width: 100%;
                        span {
                            color: pink;
                        }
                        img {
                            width: 100%;
                            height: auto;
                        }
                    }
                    img {
                        width: 100%;
                        height: auto;
                    }
                }
            }
        }
    }
}


// 响应式设计
@media (max-width: 768px) {
    .newsDetailWrap {
        .newsDetail {
            padding: 16px 16px 20px 16px;
            .detail-content {
                .news-title {
                    font-size: 24px;
                }
                
                .news-meta {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 8px;
                }
            }
        }
    }
}
</style>